const List = [

    {
        image: "https://avatars.githubusercontent.com/astroidworld",
        firstName: "Akash",
        lastName: "Das",
        link: "https://github.com/astroidworld",
    },

    {
        image: "./male.png",
        firstName: "Soudip",
        lastName: "Das",
        link: "https://github.com/front-runner-sd",
    },

    {
        image: "./male.png",
        firstName: "Dhanushka",
        lastName: "Ranasinghe",
        link: "https://github.com/DhanushkaRanasinghe",
    },

    {
        image: "./female.png",
        firstName: "Olga",
        lastName: "Tkach",
        link: "https://github.com/tkacholga",
    },

    {
        image: "./male.png",
        firstName: "Devansh",
        lastName: "Gaur",
        link: "https://github.com/Devansh-gaur-1611",
    },

    {
        image: "./male.png",
        firstName: "BAIBHAV",
        lastName: "PANDA",
        link: "https://github.com/baibhav0305",
    },

    {
        image: "./male.png",
        firstName: "Ashutosh",
        lastName: "Padhy",
        link: "https://github.com/a-padhy",

    },

    {
        image: "./male.png",
        firstName: "Lucky",
        lastName: "Sharma",
        link: "https://github.com/luckysharma05",
    },

    {
        image: "./female.png",
        firstName: "Dolly",
        lastName: "Gupta",
        link: "https://github.com/dollygupta07",
    },

    {
        image: "./male.png",
        firstName: "Aditya",
        lastName: "Jha",
        link: "https://github.com/Adityajha0808",
    },

    {
        image: "./male.png",
        firstName: "Sourav",
        lastName: "Panigrahi",
        link: "https://github.com/souravpanigrahi",
    },

    {
        image: "https://avatars.githubusercontent.com/oaparecido",
        firstName: "Daniel",
        lastName: "Aparecido",
        link: "https://github.com/oaparecido",
    },

    {
        image: "./male.png",
        firstName: "Paulo",
        lastName: "Vitor",
        link: "https://github.com/PauloVLB",
    },

    {
        image: "./male.png",
        firstName: "Kartik",
        lastName: "Rajput",
        link: "https://github.com/kartikvirendrar",
    },

    {
        image: "./female.png",
        firstName: "Kézia",
        lastName: "Ketillen",
        link: "https://github.com/Kk3tillen",
    },

    {
        image: "./male.png",
        firstName: "Isaac",
        lastName: "Lourenço",
        link: "https://github.com/isaacmsl",
    },


    {
        image: "./male.png",
        firstName: "Jam",
        lastName: "Stanley",
        link: "https://github.com/jamstanley",
    },

    {
        image: "https://avatars.githubusercontent.com/MananDudhwala",
        firstName: "Manan",
        lastName: "Dudhwala",
        link: "https://github.com/MananDudhwala"
    },

    {
        image: "https://avatars.githubusercontent.com/Rharsh750",
        firstName: "Harsh",
        lastName: "Rudani",
        link: "https://github.com/Rharsh750"
    },

    {
        image: "./male.png",
        firstName: "Priyanshu",
        lastName: "Mehra",
        link: "https://github.com/Priyanshu95663",
    },

    {
        image: "./male.png",
        firstName: "Naiwrit",
        lastName: "Mullick",
        link: "https://github.com/mnaiwrit52",

    },

    {
        image: "./male.png",
        firstName: "Rony",
        lastName: "singh",
        link: "https://github.com/Unferno",
    },

    {
        image: "https://avatars.githubusercontent.com/romiljain23",
        firstName: "Romil",
        lastName: "Jain",
        link: "https://github.com/romiljain23",
    },

    {
        image: "./male.png",
        firstName: "Paul",
        lastName: "Jeremiah",
        link: "https://github.com/0xcyberpj",
    },
    {
        image: "./male.png",
        firstName: "Pranjit",
        lastName: "Medhi",
        link: "https://github.com/real-zit",
    },

    {
        image: "./male.png",
        firstName: "Paras",
        lastName: "Dua",
        link: "https://github.com/paras22",
    },

    {
        image: "https://avatars.githubusercontent.com/vishaaal",
        firstName: "Vishal",
        lastName: "Kumar",
        link: "https://github.com/vishaaal",
    },

    {
        image: "./male.png",
        firstName: "Arsh",
        lastName: "Manva",
        link: "https://github.com/hidekiriyuga",
    },


    {
        image: "https://avatars.githubusercontent.com/zulmarij",
        firstName: "Zul",
        lastName: "Marij",
        link: "https://github.com/zulmarij",
    },


    {
        image: "./male.png",
        firstName: "Gokul",
        lastName: "AP",
        link: "https://github.com/gokulapap",
    },

    {
        image: "./male.png",
        firstName: "Rohan",
        lastName: "Goyal",
        link: "https://github.com/GoyalRohan",
    },
    {
        image: "./male.png",
        firstName: "Ankit",
        lastName: "Kandpal",
        link: "https://github.com/ak-create",
    },

    {
        image: "./male.png",
        firstName: "Anshul",
        lastName: "kumar",
        link: "https://github.com/Anshul123kumar",
    },
    {
        image: "./male.png",
        firstName: "Akshay",
        lastName: "Chopade",
        link: "https://github.com/akshay399",
    },

    {
        image: "https://avatars.githubusercontent.com/JayantGoel001",
        firstName: "Jayant",
        lastName: "Goel",
        link: "https://github.com/JayantGoel001/",
    },
    {
        image: "https://avatars.githubusercontent.com/raghavkh30",
        firstName: "Raghav",
        lastName: "kumar",
        link: "https://github.com/raghavkh30/",
    },

    {
        image: "https://avatars.githubusercontent.com/tiago-rodrigues1",
        firstName: "Tiago",
        lastName: "Rodrigues",
        link: "https://github.com/tiago-rodrigues1",
    },

    {
        image: "https://avatars.githubusercontent.com/Dipesh123-ux",
        firstName: "Dipesh",
        lastName: "Jaswani",
        link: "https://github.com/Dipesh123-ux",
    },
    {
        image: "./male.png",
        firstName: "Rishab",
        lastName: "Sharma",
        link: "https://github.com/rishab9750",
    },

    {
        image: '/images/male.png',
        firstName: 'Thana',
        lastName: 'T',
        link: 'https://github.com/exithere',
    },

    {
        image: "https://avatars.githubusercontent.com/AnkitLenka26",
        firstName: "Ankit",
        lastName: "Lenka",
        link: "https://github.com/AnkitLenka26/",
    },

    {
        image: "https://avatars.githubusercontent.com/tataisarkar",
        firstName: "Pranjal",
        lastName: "Sarkar",
        link: "https://github.com/tataisarkar/",
    },

    {
        image: "./male.png",
        firstName: "Abhik",
        lastName: "Chakrabortty",
        link: "https://github.com/myname-abhik",
    },


    {
        image: "https://avatars.githubusercontent.com/youtanimstar",
        firstName: "Deep",
        lastName: "Das",
        link: "https://github.com/youtanimstar",
    },

    {
        image: "./female.png",
        firstName: "Soumali",
        lastName: "Sau",
        link: "https://github.com/codersoumali",
    },

    {
        image: "https://avatars.githubusercontent.com/dave-mash",
        firstName: "David",
        lastName: "Mwangi",
        link: "https://github.com/dave-mash",
    }

];

export default List;